/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext, useContext } from 'react';

const getOrderRoute = (id: number): string => '';
const getOrderDuplicateRoute = (id: number): string => '';
const getDossierRoute = (id: number): string => '';
const getDossiersListeRoute = (): string => '';
const getDossierValidationRoute = (id: number): string | undefined => '';
const getAddFormalityRoute = (id: number): string | undefined => '';

const DossierRoutingContext = createContext({
    getOrderRoute,
    getOrderDuplicateRoute,
    getDossierRoute,
    getDossiersListeRoute,
    getDossierValidationRoute,
    getAddFormalityRoute,
});

export const useDossierRoutingContext = () => useContext(DossierRoutingContext);

export default DossierRoutingContext;
